<template>
  <div class="d-flex flex-column h-100 pt-3 left-menu-wrapper">
    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(0, true)" @mouseleave="setHover(0, false)"
      @click="clickMenu(0)"
      :class="{ 'select-menu-color': isSelectColor(0) }"
    >
      <div class="menu-icon my-auto">
        <svg class="d-block" :style="{fill: isHovers[0] || isSelectColor(0)? '#FFFFFF':'#8C9BC6'}"  width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.84766 19.6752C9.84766 19.3252 9.98099 18.9919 10.206 18.7419C10.4393 18.4919 10.7477 18.3586 11.0727 18.3586C11.3977 18.3586 11.706 18.5002 11.9393 18.7419C12.1727 18.9919 12.2977 19.3252 12.2977 19.6752C12.2977 19.8502 12.3643 20.0169 12.481 20.1419C12.5977 20.2669 12.756 20.3336 12.9143 20.3336C13.0727 20.3336 13.231 20.2669 13.3477 20.1419C13.4643 20.0169 13.531 19.8502 13.531 19.6752C13.531 19.3252 13.6643 18.9919 13.8893 18.7419C14.1227 18.4919 14.431 18.3586 14.756 18.3586C15.081 18.3586 15.3893 18.5002 15.6227 18.7419C15.856 18.9919 15.981 19.3252 15.981 19.6752C15.981 20.5502 15.656 21.3836 15.081 22.0002C14.506 22.6169 13.7227 22.9586 12.9143 22.9586C12.106 22.9586 11.3227 22.6086 10.7477 22.0002C10.1727 21.3836 9.84766 20.5502 9.84766 19.6752Z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4987 16.883C22.4987 16.208 22.332 15.5414 22.0237 14.9414C21.707 14.3414 21.257 13.833 20.707 13.4497L20.707 11.0914C20.707 9.17471 19.9487 7.33305 18.5987 5.98305C17.2487 4.62471 15.4237 3.86638 13.5154 3.86638L12.3154 3.86638C10.407 3.86638 8.58203 4.62471 7.23203 5.98305C5.88203 7.34138 5.1237 9.17471 5.1237 11.0914L5.1237 13.4497C4.5737 13.833 4.11537 14.3497 3.80703 14.9414C3.4987 15.5414 3.33203 16.208 3.33203 16.883C3.33203 17.683 3.6487 18.4497 4.20703 19.0164C4.76537 19.583 5.53203 19.8997 6.3237 19.8997L19.4987 19.8997C20.2904 19.8997 21.057 19.583 21.6154 19.0164C22.1737 18.4497 22.4904 17.683 22.4904 16.883L22.4987 16.883ZM18.307 14.933L19.0154 15.2497L19.082 15.2747C19.707 15.558 20.107 16.183 20.107 16.8747C20.107 17.033 20.0404 17.1914 19.932 17.2997C19.8237 17.4164 19.6654 17.4747 19.507 17.4747L6.3237 17.4747C6.16537 17.4747 6.01537 17.408 5.8987 17.2997C5.79037 17.183 5.7237 17.033 5.7237 16.8747C5.7237 16.183 6.1237 15.558 6.7487 15.2747L6.81537 15.2497L7.5237 14.933L7.5237 11.0914C7.5237 9.81638 8.03203 8.59138 8.9237 7.68305C9.8237 6.78305 11.0404 6.27471 12.3154 6.27471L13.5154 6.27471C14.782 6.27471 16.007 6.78305 16.907 7.68305C17.807 8.58305 18.307 9.81638 18.307 11.0914L18.307 14.933Z"/>
        <path d="M11.7656 2.85834C11.7656 2.54167 11.8906 2.24167 12.099 2.01667C12.3156 1.79167 12.6073 1.66667 12.9156 1.66667C13.224 1.66667 13.5156 1.79167 13.7323 2.01667C13.949 2.24167 14.0656 2.54167 14.0656 2.85834L14.0656 4.96667C14.0656 5.28334 13.9406 5.58334 13.7323 5.80834C13.5156 6.03334 13.224 6.15834 12.9156 6.15834C12.6073 6.15834 12.3156 6.03334 12.099 5.80834C11.8823 5.58334 11.7656 5.28334 11.7656 4.96667L11.7656 2.85834Z"/>
        </svg>
      </div>
      <div class="">お知らせ</div>
    </div>

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(3, true)" @mouseleave="setHover(3, false)"
      @click="clickMenu(3)"
      :class="{ 'select-menu-color': isSelectColor(3) }"
    >
      <div class="menu-icon my-auto">
        <svg class="d-block" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path :style="{fill: isHovers[3] || isSelectColor(3)? '#FFFFFF':'#8C9BC6'}" d="M12.908 2.5C7.61634 2.5 3.33301 6.79167 3.33301 12.0833C3.33301 17.375 7.61634 21.6667 12.908 21.6667C18.1997 21.6667 22.4997 17.375 22.4997 12.0833C22.4997 6.79167 18.208 2.5 12.908 2.5ZM12.9163 19.75C8.68301 19.75 5.24968 16.3167 5.24968 12.0833C5.24968 7.85 8.68301 4.41667 12.9163 4.41667C17.1497 4.41667 20.583 7.85 20.583 12.0833C20.583 16.3167 17.1497 19.75 12.9163 19.75Z" fill="#8C9BC6"/>
        <path :style="{fill: isHovers[3] || isSelectColor(3)? '#FFFFFF':'#8C9BC6'}" d="M13.3997 7.2915L11.958 7.2915L11.958 13.0415L16.9913 16.0582L17.708 14.8832L13.3997 12.3248L13.3997 7.2915Z" fill="#8C9BC6"/>
        </svg>
      </div>
      <div class="">注文履歴</div>
    </div>

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(4, true)" @mouseleave="setHover(4, false)"
      @click="clickMenu(4)"
      :class="{ 'select-menu-color': isSelectColor(4) }"
    >
      <div class="menu-icon my-auto">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path :style="{fill: isHovers[4] || isSelectColor(4)? '#FFFFFF':'#8C9BC6'}" d="M11.2404 13.0417C11.2404 13.2 11.207 13.3583 11.1487 13.5C11.0904 13.6417 10.9987 13.775 10.8904 13.8917C10.782 14 10.6487 14.0917 10.4987 14.15C10.3487 14.2083 10.1987 14.2417 10.0404 14.2417C9.7237 14.2417 9.41537 14.1167 9.19037 13.8917C8.96537 13.6667 8.84037 13.3583 8.84037 13.0417C8.84037 12.725 8.96537 12.4167 9.19037 12.1917C9.41537 11.9667 9.7237 11.8417 10.0404 11.8417C10.1987 11.8417 10.357 11.875 10.4987 11.9333C10.6404 11.9917 10.7737 12.0833 10.8904 12.1917C10.9987 12.3 11.0904 12.4333 11.1487 12.5833C11.207 12.725 11.2404 12.8833 11.2404 13.0417ZM15.7904 11.8417C15.4737 11.8417 15.1654 11.9667 14.9404 12.1917C14.7154 12.4167 14.5904 12.725 14.5904 13.0417C14.5904 13.3583 14.7154 13.6667 14.9404 13.8917C15.1654 14.1167 15.4737 14.2417 15.7904 14.2417C16.107 14.2417 16.4154 14.1167 16.6404 13.8917C16.8654 13.6667 16.9904 13.3583 16.9904 13.0417C16.9904 12.725 16.8654 12.4167 16.6404 12.1917C16.4154 11.9667 16.107 11.8417 15.7904 11.8417ZM22.4987 12.0833C22.4987 14.625 21.4904 17.0667 19.6904 18.8583C17.8904 20.6583 15.457 21.6667 12.9154 21.6667C11.657 21.6667 10.407 21.4167 9.2487 20.9333C8.08203 20.45 7.03203 19.7417 6.14037 18.8583C4.34037 17.0667 3.33203 14.625 3.33203 12.0833C3.33203 9.54167 4.34037 7.1 6.14037 5.30833C7.93203 3.50833 10.3737 2.5 12.9154 2.5C14.1737 2.5 15.4237 2.75 16.582 3.23333C17.7487 3.71667 18.7987 4.425 19.6904 5.30833C20.582 6.2 21.282 7.25833 21.7654 8.41667C22.2487 9.58333 22.4987 10.825 22.4987 12.0833ZM11.632 4.53333C12.9737 6.75833 15.407 8.25 18.1904 8.25C18.632 8.25 19.0654 8.2 19.4737 8.13333C18.132 5.90833 15.6987 4.41667 12.9154 4.41667C12.4737 4.41667 12.0404 4.46667 11.632 4.53333ZM5.6487 9.65833C7.2987 8.725 8.5487 7.20833 9.15703 5.4C7.50703 6.33333 6.25703 7.85 5.6487 9.65833ZM20.582 12.0833C20.582 11.3333 20.4654 10.6167 20.2654 9.93333C19.5904 10.075 18.907 10.1667 18.182 10.1667C16.757 10.1667 15.3487 9.85 14.0654 9.24167C12.782 8.63333 11.6487 7.74167 10.7487 6.63333C10.2487 7.85 9.4987 8.95 8.5487 9.86667C7.5987 10.7833 6.48203 11.4917 5.2487 11.9583L5.2487 12.0917C5.2487 16.3167 8.69037 19.7583 12.9154 19.7583C17.1404 19.7583 20.582 16.3167 20.582 12.0917L20.582 12.0833Z"/>
        </svg>
      </div>
      <div class="">お客様情報・配送先</div>
    </div>

    <hr style="margin: 16px 10px; color: #B1C0DB; height: 1px;">

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(1, true)" @mouseleave="setHover(1, false)"
      @click="clickMenu(1)"
      :class="{ 'select-menu-color': isSelectColor(1) }"
    >
      <div class="menu-icon my-auto">
        <svg class="d-block" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path :style="{fill: isHovers[1] || isSelectColor(1)? '#FFFFFF':'#8C9BC6'}" d="M15.1394 14.9082C15.0144 14.9082 14.8894 14.9082 14.7727 14.8749L12.8477 14.5832C11.8311 14.4332 11.0477 13.6666 10.8811 12.6749L10.5811 10.8166C10.4561 10.0582 10.7227 9.2749 11.2977 8.7249L16.1144 4.05823C17.0811 3.11656 18.6311 3.09156 19.5727 3.9999L21.7977 6.15823C22.2644 6.60823 22.4977 7.1999 22.4894 7.8499C22.4727 8.48323 22.2144 9.06656 21.7477 9.51656L16.9311 14.1916C16.4477 14.6582 15.8061 14.9082 15.1477 14.9082L15.1394 14.9082ZM17.8977 4.93323C17.6811 4.93323 17.4561 5.0249 17.2811 5.18323L12.4644 9.85823C12.2727 10.0499 12.1644 10.3166 12.2061 10.5666L12.5061 12.4249C12.5561 12.7249 12.7811 12.9416 13.0894 12.9916L15.0144 13.2832C15.2727 13.3249 15.5477 13.2332 15.7477 13.0332L20.5644 8.35823C20.7311 8.1999 20.8227 7.9999 20.8227 7.7749C20.8227 7.5749 20.7477 7.39156 20.6144 7.26656L18.3894 5.10823C18.2561 4.9749 18.0727 4.90823 17.8727 4.90823L17.8894 4.9249L17.8977 4.93323Z"/>
        <path :style="{fill: isHovers[1] || isSelectColor(1)? '#FFFFFF':'#8C9BC6'}" d="M16.4401 5.34995L15.2734 6.48328L19.3234 10.4166L20.4901 9.28328L16.4401 5.34995Z"/>
        <path :style="{stroke: isHovers[1] || isSelectColor(1)? '#FFFFFF':'#8C9BC6'}" d="M21.574 13.1416L21.574 18.8665C21.574 20.4082 20.2823 21.6665 18.6906 21.6665L7.02396 21.6665C5.44063 21.6665 4.14063 20.4082 4.14063 18.8665L4.14063 7.53322C4.14063 5.99155 5.43229 4.73322 7.02396 4.73322L12.324 4.73322" stroke-width="1.96" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="">アクリルアイテム</div>
    </div>

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(6, true)" @mouseleave="setHover(6, false)"
      @click="clickMenu(6)"
      :class="{ 'select-menu-color': isSelectColor(6) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg class="d-block" width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path :style="{fill: isHovers[6] || isSelectColor(6)? '#FFFFFF':'#8C9BC6'}" d="M11.7073 13.607L12.1073 15.807C12.3073 17.007 13.2073 17.907 14.4073 18.107L16.6073 18.507C16.7073 18.507 16.9073 18.507 17.0073 18.507C17.8073 18.507 18.6073 18.207 19.0073 17.607L24.7073 12.007C25.3073 11.507 25.6073 10.807 25.6073 9.90705C25.6073 9.00705 25.3073 8.40705 24.8073 7.90705L22.2073 5.30705C21.1073 4.20705 19.3073 4.20705 18.2073 5.40705L12.5073 11.107C11.8073 11.707 11.5073 12.707 11.7073 13.607ZM20.2073 6.40705C20.4073 6.40705 20.6073 6.50705 20.8073 6.60705L23.4073 9.20705C23.6073 9.40705 23.6073 9.60705 23.6073 9.80705C23.6073 10.107 23.5073 10.307 23.3073 10.507L22.7073 11.107L18.9073 7.30705L19.6073 6.70705C19.7073 6.50705 19.9073 6.40705 20.2073 6.40705ZM13.9073 12.407L17.6073 8.60705L21.4073 12.507L17.7073 16.207C17.5073 16.407 17.1073 16.607 16.8073 16.507L14.6073 16.207C14.2073 16.107 14.0073 15.907 13.9073 15.507L13.5073 13.307C13.5073 13.007 13.6073 12.607 13.9073 12.407Z" fill="#595959"/>
        <path :style="{fill: isHovers[6] || isSelectColor(6)? '#FFFFFF':'#8C9BC6'}" d="M25.1078 14.5068C24.6078 14.5068 24.1078 14.9068 24.1078 15.5068V21.3068C24.1078 22.6068 23.0078 23.7068 21.7078 23.7068H8.20781C7.00781 23.5068 5.90781 22.5068 5.90781 21.2068V8.80684C5.90781 7.50684 7.00781 6.50684 8.30781 6.50684H14.5078C15.0078 6.50684 15.5078 6.10684 15.5078 5.50684C15.5078 4.90684 15.1078 4.50684 14.5078 4.50684H8.20781C5.90781 4.60684 4.00781 6.50684 4.00781 8.80684V21.2068C4.00781 23.5068 5.90781 25.5068 8.20781 25.5068H21.7078C24.0078 25.5068 25.9078 23.6068 25.9078 21.3068V15.5068C26.1078 14.9068 25.6078 14.5068 25.1078 14.5068Z" fill="#595959"/>
        <path :style="{fill: isHovers[6] || isSelectColor(6)? '#FFFFFF':'#8C9BC6'}" d="M7.20781 18.607C7.20781 17.607 8.00781 16.707 9.60781 16.707C11.2078 16.707 11.8078 17.607 11.8078 18.007C11.8078 18.407 11.4078 18.807 11.0078 18.807C10.8078 18.807 10.6078 18.707 10.4078 18.507C10.2078 18.207 9.70781 18.107 9.50781 18.107C9.00781 18.107 8.70781 18.207 8.70781 18.507C8.70781 18.607 8.80781 18.707 8.80781 18.707C9.20781 18.807 9.60781 18.907 10.3078 19.007C11.4078 19.307 11.9078 19.807 11.9078 20.907C11.9078 22.007 11.0078 22.807 9.40781 22.807C7.50781 22.807 7.00781 21.607 7.00781 21.207C7.00781 20.807 7.40781 20.407 7.80781 20.407C8.00781 20.407 8.20781 20.507 8.30781 20.807C8.50781 21.207 8.80781 21.407 9.40781 21.407C10.0078 21.407 10.3078 21.207 10.3078 20.907C10.3078 20.707 10.1078 20.507 9.90781 20.407C9.20781 20.207 8.60781 20.207 7.90781 20.007C7.40781 19.807 7.20781 19.207 7.20781 18.607Z" fill="#595959"/>
        </svg>
      </div>
      <div class="">サンプル注文</div>
    </div>

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(2, true)" @mouseleave="setHover(2, false)"
      @click="clickMenu(2)"
      :class="{ 'select-menu-color': isSelectColor(2) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg class="d-block" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path :style="{fill: isHovers[2] || isSelectColor(2)? '#FFFFFF':'#8C9BC6'}" d="M15.1755 14.0334C15.0505 14.0334 14.9255 14.0334 14.8088 14.0001L12.8921 13.7084C11.8755 13.5584 11.1005 12.7918 10.9338 11.8084L10.6338 9.95844C10.5088 9.2001 10.7755 8.4251 11.3505 7.8751L16.1421 3.2251C17.1088 2.29177 18.6505 2.25844 19.5838 3.16677L21.8005 5.31677C22.2588 5.76677 22.5005 6.3501 22.4838 7.0001C22.4671 7.6251 22.2088 8.21677 21.7421 8.66677L16.9421 13.3251C16.4588 13.7918 15.8255 14.0418 15.1671 14.0418L15.1588 14.0418L15.1755 14.0334ZM17.9255 4.09177C17.7088 4.09177 17.4838 4.18344 17.3088 4.34177L12.5088 9.0001C12.3171 9.19177 12.2088 9.45844 12.2505 9.70844L12.5505 11.5584C12.6005 11.8584 12.8255 12.0751 13.1338 12.1251L15.0505 12.4168C15.3088 12.4584 15.5838 12.3668 15.7755 12.1668L20.5755 7.50844C20.7421 7.3501 20.8338 7.1501 20.8338 6.93344C20.8338 6.73344 20.7588 6.55844 20.6255 6.4251L18.4088 4.2751C18.2755 4.14177 18.0921 4.0751 17.9005 4.0751L17.9171 4.09177L17.9255 4.09177Z" fill="#8C9BC6"/>
        <path :style="{fill: isHovers[2] || isSelectColor(2)? '#FFFFFF':'#8C9BC6'}" d="M16.466 4.5083L15.3076 5.6333L19.341 9.5583L20.4993 8.4333L16.466 4.5083Z" fill="#8C9BC6"/>
        <path :style="{fill: isHovers[2] || isSelectColor(2)? '#FFFFFF':'#8C9BC6'}" d="M18.6497 21.667L18.5163 21.667L18.5163 19.6753L18.6497 19.6753C19.058 19.6753 19.4497 19.5336 19.7747 19.2836L21.0663 20.8253C20.383 21.367 19.533 21.6586 18.6497 21.6586L18.6497 21.667ZM17.4913 21.667L15.4413 21.667L15.4413 19.6753L17.4913 19.6753L17.4913 21.667ZM14.4163 21.667L12.3663 21.667L12.3663 19.6753L14.4163 19.6753L14.4163 21.667ZM11.3413 21.667L9.29134 21.667L9.29134 19.6753L11.3413 19.6753L11.3413 21.667ZM8.26634 21.667L7.18301 21.667C6.74134 21.667 6.29968 21.6003 5.89134 21.4503L6.57468 19.5753C6.76634 19.642 6.97468 19.6753 7.18301 19.6753L8.26634 19.6753L8.26634 21.667ZM4.69134 20.767C3.97468 20.167 3.49968 19.342 3.36634 18.4503L5.39968 18.1753C5.45801 18.592 5.67468 18.9836 6.01634 19.2586L4.68301 20.7753L4.69134 20.7753L4.69134 20.767ZM21.9747 19.8086L20.208 18.8003C20.3747 18.5336 20.458 18.2336 20.458 17.9253L20.458 17.3836L22.508 17.3836L22.508 17.9253C22.508 18.592 22.3247 19.242 21.983 19.8086L21.9747 19.8086ZM5.39134 17.3086L3.33301 17.3086L3.33301 15.317L5.38301 15.317L5.38301 17.3086L5.39134 17.3086ZM22.508 16.3836L20.458 16.3836L20.458 14.392L22.508 14.392L22.508 16.3836ZM5.38301 14.3253L3.33301 14.3253L3.33301 12.3336L5.38301 12.3336L5.38301 14.3253ZM22.4997 13.4003L20.4497 13.4003L20.4497 11.4086L22.4997 11.4086L22.4997 13.4003ZM5.38301 11.342L3.33301 11.342L3.33301 9.35029L5.38301 9.35029L5.38301 11.342ZM5.38301 8.35029L3.33301 8.35029L3.33301 6.78363C3.33301 6.58363 3.34968 6.38363 3.38301 6.19196L5.39968 6.50863C5.39134 6.60029 5.38301 6.69196 5.38301 6.77529L5.38301 8.34196L5.38301 8.35029ZM5.61634 5.91696L3.84134 4.92529C4.31634 4.12529 5.05801 3.53363 5.94134 3.24196L6.59968 5.12529C6.18301 5.26696 5.83301 5.54196 5.60801 5.92529L5.61634 5.92529L5.61634 5.91696ZM12.408 5.03363L10.358 5.03363L10.358 3.05029L12.408 3.05029L12.408 5.04196L12.408 5.03363ZM9.33301 5.03363L7.28301 5.03363L7.28301 3.05029L9.33301 3.05029L9.33301 5.04196L9.33301 5.03363Z" fill="#8C9BC6"/>
        </svg>
      </div>
      <div class="">下書き・デザイン履歴</div>
    </div>

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(5, true)" @mouseleave="setHover(5, false)"
      @click="clickMenu(5)"
      :class="{ 'select-menu-color': isSelectColor(5) }"
    >
      <div class="menu-icon ml-2 my-auto">
        <svg class="d-block" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path :style="{fill: isHovers[5] || isSelectColor(5)? '#FFFFFF':'#8C9BC6'}" d="M12.3746 21.6673C11.8163 21.6673 11.2579 21.5756 10.7246 21.4006C9.25794 20.8923 8.12461 19.7256 7.67461 18.2923L5.83294 12.434C5.44961 11.209 5.57461 9.91729 6.19127 8.77562C6.80794 7.64229 7.84128 6.80895 9.09961 6.43395C10.3579 6.05895 11.6913 6.18396 12.8579 6.78396C13.9329 7.34229 14.7413 8.23395 15.1663 9.33395C17.3829 8.13396 20.2246 8.78396 21.6579 10.8756C23.1663 13.0756 22.5579 16.059 20.2913 17.534L18.9246 18.4173C18.5163 18.684 17.9663 18.5673 17.6996 18.1756C17.4329 17.784 17.5413 17.2506 17.9496 16.984L19.3163 16.109C20.7663 15.1673 21.1663 13.2506 20.1913 11.834C19.2163 10.4173 17.2496 10.034 15.7996 10.9756L15.1663 11.3923C14.9329 11.5423 14.6413 11.5756 14.3746 11.4923C14.1079 11.4006 13.9079 11.1923 13.8246 10.9256L13.5746 10.1256C13.3246 9.35062 12.7746 8.70062 12.0329 8.31729C11.2829 7.93395 10.4246 7.85062 9.61628 8.09229C8.80794 8.33395 8.14127 8.86729 7.74961 9.60062C7.34961 10.3256 7.26627 11.159 7.51627 11.9506L9.35794 17.809C9.64961 18.734 10.3746 19.4756 11.3079 19.8006C12.2663 20.1256 13.2996 20.0006 14.1329 19.459L14.7663 19.0423C15.1746 18.7756 15.7163 18.884 15.9913 19.2756C16.2663 19.6673 16.1579 20.2006 15.7496 20.4673L15.1079 20.884C14.2913 21.4173 13.3329 21.6923 12.3579 21.6923L12.3746 21.6673Z" fill="#8C9BC6"/>
        <path :style="{fill: isHovers[5] || isSelectColor(5)? '#FFFFFF':'#8C9BC6'}" d="M8.29174 12.1503C7.05841 12.1503 5.88341 11.717 4.95841 10.9087C3.97508 10.0337 3.40008 8.85034 3.33341 7.55867C3.20841 4.91701 5.31674 2.65034 8.04174 2.50034C9.37508 2.43367 10.6417 2.86701 11.6167 3.73367C12.6001 4.60034 13.1834 5.78367 13.2417 7.08367C13.2667 7.55867 12.8834 7.96701 12.3917 7.99201C11.9084 8.03367 11.4834 7.65034 11.4584 7.16701C11.4167 6.33367 11.0501 5.57534 10.4167 5.01701C9.78341 4.46701 8.97508 4.18367 8.12508 4.23367C6.34174 4.32534 5.01674 5.75867 5.10008 7.48367C5.14174 8.30867 5.50841 9.06701 6.14174 9.62534C6.77508 10.1753 7.59174 10.467 8.44174 10.4253C8.88341 10.4087 9.32508 10.292 9.75841 10.0753C10.2001 9.85867 10.7334 10.0253 10.9584 10.4503C11.1834 10.8753 11.0084 11.392 10.5751 11.617C9.91674 11.942 9.22508 12.1253 8.52508 12.1587C8.44174 12.1587 8.36674 12.1587 8.28341 12.1587L8.29174 12.1503Z" fill="#8C9BC6"/>
        </svg>
      </div>
      <div class="">オプションアイテム</div>
    </div>

    <hr style="margin: 16px 10px; color: #B1C0DB; height: 1px;">

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(8, true)" @mouseleave="setHover(8, false)"
      @click="clickMenu(8)"
      :class="{ 'select-menu-color': isSelectColor(8) }"
    >
      <div class="menu-icon my-auto" style="margin-top: -1px;" :style="{stroke: isHovers[8] || isSelectColor(8)? '#FFFFFF':'#8C9BC6'}">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path d="M21 12.5L12.5 21C10.8189 21 9.17547 20.5015 7.77766 19.5675C6.37984 18.6335 5.29037 17.306 4.64703 15.7528C4.00368 14.1996 3.83535 12.4906 4.16333 10.8417C4.4913 9.1929 5.30085 7.67834 6.4896 6.4896C7.67834 5.30085 9.1929 4.4913 10.8417 4.16333C12.4906 3.83535 14.1996 4.00368 15.7528 4.64703C17.306 5.29037 18.6335 6.37984 19.5675 7.77766C20.5015 9.17547 21 10.8189 21 12.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.9981 21.0001C11.6037 20.016 11.4229 18.9594 11.4676 17.9002C11.4754 16.1999 12.1564 14.5718 13.3616 13.3722C14.5668 12.1727 16.198 11.4994 17.8985 11.4997C18.9574 11.4593 20.0131 11.6399 20.9983 12.0302" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="">アクリープリント</div>
    </div>

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(9, true)" @mouseleave="setHover(9, false)"
      @click="clickMenu(9)"
      :class="{ 'select-menu-color': isSelectColor(9) }"
    >
      <div class="menu-icon my-auto" style="padding-top: 1px; padding-left: 3px;" :style="{fill: isHovers[9] || isSelectColor(9)? '#FFFFFF':'#8C9BC6'}">
        <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.04888 0.192376C9.98872 -0.193482 11.9999 0.00370362 13.8272 0.760581C15.6545 1.51746 17.2164 2.79948 18.3153 4.44397C19.4141 6.08851 20 8.02257 20 10.0004C19.9999 10.2845 19.887 10.5572 19.6861 10.758L10.758 19.6861C10.5572 19.8869 10.2845 19.9999 10.0004 20C8.02257 20 6.08851 19.4141 4.44397 18.3153C2.79948 17.2164 1.51746 15.6545 0.760581 13.8272C0.00370301 11.9999 -0.193482 9.98872 0.192377 8.04887C0.578284 6.10914 1.53028 4.32724 2.92876 2.92876C4.32724 1.53028 6.10915 0.578283 8.04888 0.192376ZM13.0068 2.74145C11.5712 2.14679 9.99152 1.99047 8.46744 2.29358C6.94329 2.59675 5.54282 3.34512 4.44397 4.44397C3.34512 5.54282 2.59675 6.94329 2.29358 8.46744C1.99047 9.99152 2.14679 11.5712 2.74145 13.0068C3.33614 14.4425 4.3427 15.6699 5.63479 16.5332C6.80718 17.3166 8.16666 17.7663 9.56932 17.8433L17.8433 9.56932C17.7663 8.16666 17.3166 6.80718 16.5332 5.63479C15.6699 4.3427 14.4425 3.33614 13.0068 2.74145Z"/>
        <path d="M15.6889 8.00656C16.9333 7.95892 18.1741 8.17105 19.3318 8.6309C19.8746 8.84652 20.1404 9.46258 19.9255 10.0069C19.7104 10.5513 19.0961 10.8179 18.5532 10.6023C17.6686 10.2509 16.7203 10.0885 15.7695 10.1249C15.7561 10.1255 15.7426 10.126 15.7292 10.126C14.2464 10.1258 12.8235 10.714 11.7725 11.7629C10.7216 12.8117 10.1283 14.2355 10.1214 15.7222C10.1214 15.7355 10.121 15.7493 10.1204 15.7626C10.0804 16.7134 10.2423 17.6623 10.5954 18.5457C10.8123 19.0891 10.5487 19.706 10.0068 19.9237C9.46485 20.1415 8.84973 19.877 8.63251 19.3336C8.16814 18.1716 7.95525 16.9242 8.00782 15.6735C8.02739 13.6401 8.84339 11.6958 10.2815 10.2606C11.7193 8.82566 13.6615 8.01695 15.6889 8.00656Z"/>
        <path d="M5.33268 6.75033C5.33268 5.91699 5.99935 5.16699 7.33268 5.16699C8.66602 5.16699 9.16602 5.91699 9.16602 6.25033C9.16602 6.58366 8.83268 6.91699 8.49935 6.91699C8.33268 6.91699 8.16602 6.83366 7.99935 6.66699C7.83268 6.41699 7.41602 6.33366 7.24935 6.33366C6.83268 6.33366 6.58268 6.41699 6.58268 6.66699C6.58268 6.75033 6.66602 6.83366 6.66602 6.83366C6.99935 6.91699 7.33268 7.00033 7.91602 7.08366C8.83268 7.33366 9.24935 7.75033 9.24935 8.66699C9.24935 9.58366 8.49935 10.2503 7.16602 10.2503C5.58268 10.2503 5.16602 9.25033 5.16602 8.91699C5.16602 8.58366 5.49935 8.25032 5.83268 8.25032C5.99935 8.25032 6.16602 8.33366 6.24935 8.58366C6.41602 8.91699 6.66602 9.08366 7.16602 9.08366C7.66602 9.08366 7.91602 8.91699 7.91602 8.66699C7.91602 8.50033 7.74935 8.33366 7.58268 8.25033C6.99935 8.08366 6.49935 8.08366 5.91602 7.91699C5.49935 7.75033 5.33268 7.25033 5.33268 6.75033Z"/>
        </svg>
      </div>
      <div class="">サンプル注文</div>
    </div>

    <hr style="margin: 16px 10px; color: #B1C0DB; height: 1px;">

    <div
      class="menu-cell text-start d-flex"
      @mouseover="setHover(7, true)" @mouseleave="setHover(7, false)"
      @click="clickMenu(7)"
      :class="{ 'select-menu-color': isSelectColor(7) }"
    >
      <div class="menu-icon my-auto" :style="{stroke: isHovers[7] || isSelectColor(7)? '#FFFFFF':'#8C9BC6'}">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.2287 8.09231C16.884 7.74597 16.78 7.265 16.8937 6.82962C16.9923 6.46181 16.9256 6.07107 16.6559 5.80002L15.3221 4.45981C14.4154 3.54877 12.9357 3.54521 12.0172 4.45185L4.43521 12.0049C3.52417 12.9116 3.52061 14.3913 4.42725 15.3098L5.79849 16.6877C6.03827 16.9286 6.39106 17.0271 6.7218 16.9227C7.17282 16.7811 7.67579 16.895 8.03548 17.2489C8.39516 17.6028 8.49158 18.1138 8.35529 18.5641C8.24936 18.8868 8.35365 19.2476 8.58592 19.4885L9.64994 20.5577C10.5566 21.4687 12.0363 21.4723 12.9548 20.5657L20.5443 13.0126C21.4554 12.106 21.4589 10.6263 20.5523 9.70771L19.5257 8.67621C19.256 8.40515 18.8656 8.33661 18.4973 8.43337C18.0614 8.54499 17.5809 8.43117 17.2362 8.09233L17.2287 8.09231Z" stroke-width="1.8" stroke-miterlimit="10"/>
        <path d="M10.4492 6.138L11.738 7.44054" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M13.8906 9.5943L15.3967 11.1152" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M17.3594 13.0872L18.6257 14.3521" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="">アクリーチケット管理</div>
    </div>

    <div class="text-start flex-grow-1 mt-auto d-flex flex-column-reverse">
      <div class="py-3 text-start flex-grow-1 mt-auto d-flex flex-column">
        <div class="flex-grow-1"></div>
        <div class="px-3 my-2" style="cursor: pointer;" @click="clickTemplate">
          テンプレート
        </div>
        <div class="px-3 my-2" style="cursor: pointer;" @click="clickContact">
          お問い合わせ
        </div>
        <div class="px-3 my-2" style="cursor: pointer;" @click="clickGuid">
          ご利用ガイド
        </div>
        <div class="px-3 my-2" style="cursor: pointer;" @click="clickLogout">
          ログアウト
        </div>
        <div class="py-2 px-2 mt-3 text-start company-name d-flex justify-content-between"
        v-if="this.userInfo != null && this.destinationList[this.selectedDestination].name01">
          <div style="font-size:14px;margin-top: 2px;">
            {{this.getCompanyName}}
          </div>
          <img v-if="this.$store.state.isSignature" src="@/assets/acrypro/contract_1.svg" style="width:72px;" />
          <img v-if="!this.$store.state.isSignature" src="@/assets/acrypro/contract_2.svg" style="width:72px;cursor:pointer;" @click="resendSignature" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { User } from "@/js/User.js";
import { CenterViewState, RightViewState } from "@/js/Const.js";
import firebase from "firebase/app";
import { Analytics } from "@/js/Analytics.js";
import config from 'config'
import { Logger } from '@/js/utils/Logger.js'

export default {
  name: "LeftMenu_Ap",
  props: {},
  data: function () {
    return {
      isHovers: Array(8).fill(false), // メニュー分用意
      destinationList: [],
      userInfo:null,
      selectedDestination: 0,
      selectMenuId: 0,
      email: "",
      fbUserData:null,
    };
  },
  computed: {
    isDebug(){
      return config.isDebug;
    },
    getCompanyName(){
      if( this.fbUserData && "isIndividual" in this.fbUserData && this.fbUserData.isIndividual ){
        // 個人
        return this.destinationList[this.selectedDestination].name01 + ' ' + this.destinationList[this.selectedDestination].name02;
      }else{
        // 法人
        if( this.destinationList[this.selectedDestination].company_name ){
          if( this.destinationList[this.selectedDestination].company_name.length <= 11 ){
            return this.destinationList[this.selectedDestination].company_name;
          }else{
            return this.destinationList[this.selectedDestination].company_name.slice( 0, 10 ) + '...';
          }
        }else{
          return '';
        }
      }
    }
  },
  created: async function () {
    this.selectMenuId = 0;
    await User.get
    this.fbUserData = await User.getFBAcryProUserData().catch(() => {
      console.log("エラー");
    });
    this.destinationList = await User.getDestinationList().catch((e) => {
      this.$common.log(e);
      this.$store.commit("showMessage", "エラーが発生しました");
    });
    this.userInfo = await User.getInfo();
    Logger.info(this.userInfo);
    this.email = (await User.getInfo()).email;
  },
  components: {},
  methods: {
    setHover(i, isHover) {
      this.$set(this.isHovers, i, isHover)
    },
    isSelectColor(menuId) {
      return this.selectMenuId == menuId;
    },

    clickMenu(menuId) {
      this.menuId = menuId;
      if( [CenterViewState.Preview, CenterViewState.Edit, CenterViewState.BehalfCreate,
        CenterViewState.EventCreate, CenterViewState.EventEdit, CenterViewState.EventDesignUpload,
        CenterViewState.FirstTimeFreeSurvey
      ].includes(this.$store.state.centerViewState)){
        // 編集中の場合は警告
        this.$store.commit("setYesNoDialogCallback", this.changeViewState);
        this.$store.commit("showYesNoDialog", "編集中です。\nこのページから移動しますか？");
        return;
      }

      if( [RightViewState.FirstTimeFreeUpload
      ].includes(this.$store.state.rightViewState)){
        // 編集中の場合は警告
        this.$store.commit("setYesNoDialogCallback", this.changeViewState);
        this.$store.commit("showYesNoDialog", "編集中です。\nこのページから移動しますか？");
        return;
      }

      this.changeViewState();
    },
    changeViewState(){
      this.selectMenuId = this.menuId;
      this.$store.commit("setIsCenterViewScroll", true);

      switch (this.menuId) {
        case 0:
          this.$store.commit("setCenterViewState", CenterViewState.Info);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 1:
          this.$store.commit("setCenterViewState", CenterViewState.Upload);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 2:
          this.$store.commit("setCenterViewState", CenterViewState.Draft);
          this.$store.commit("setRightViewState", RightViewState.Draft);
          break;
        case 3:
          this.$store.commit("setCenterViewState", CenterViewState.OrderHistory);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 4:
          this.$store.commit("setCenterViewState", CenterViewState.Shipping);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 5:
          this.$store.commit("setCenterViewState", CenterViewState.Option);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 6:
          this.$store.commit("setCenterViewState", CenterViewState.SampleUpload);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 7:
          this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 8:
          this.$store.commit("setCenterViewState", CenterViewState.AcryPrint);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
        case 9:
          this.$store.commit("setCenterViewState", CenterViewState.AcryPrintSample);
          this.$store.commit("setRightViewState", RightViewState.Cart);
          break;
      }
    },
    resendSignature(){
      this.$store.commit("showResendContractDialog");

    // let envelopeXID = null;
    //   await User.getFBAcryProUserData().then((data) => {
    //     if (data.envelopeXID) {
    //       envelopeXID = data.envelopeXID;
    //     }
    //   });
    //   if( envelopeXID ){
    //     // 契約書を再送信
    //     await User.resendRequest(envelopeXID).then(()=>{
    //       this.$store.commit("showMessage", "契約書を再送信しました");
    //     })
    //     .catch(()=>{
    //       this.$store.commit("showMessage", "エラーが発生しました")
    //     });
    //   }
    },
    clickTemplate(){
      this.$store.commit("setIsCenterViewScroll", true);
      this.selectMenuId = this.menuId = 99;
      this.$store.commit("setCenterViewState", CenterViewState.Template);
    },
    clickContact(){
      router.push("/contact");
    },
    clickGuid(){
      window.open('https://www.acry.jp/acryproguide', '_blank')
    },
    clickLogout(){
      this.$store.commit("setYesNoDialogCallback", this.logoutProcess);
      this.$store.commit("showYesNoDialog", "ログアウトしますか？");
    },
    logoutProcess(){
      this.$store.commit("logout");
      Analytics.setUserId(null);
      firebase
        .auth()
        .signOut()
        .then(function () {
          // this.$store.commit("resetData");
          router.push("/");
        })
        .catch((error) => {
          this.$common.log(error.message);
          // this.$store.commit("resetData");
          router.push("/");
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.menu-cell{
  cursor: pointer;
  height: 41px;
  padding: 8px 16px;
  gap: 16px;
  fill: $primary-main-color;
  font-size: 1em;
  font-weight: bold;
  color: $text-main-color;
}
.menu-cell:hover {
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}
.menu-icon{
  width: 25px;
  height: 25px;
}

.select-menu-color {
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}

.company-name{
  border: 1px solid $primary-main-color;
  background: #ffffff;
  color: $primary-main-color;
  font-weight: bold;
}

.left-menu-wrapper{
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.left-menu-wrapper::-webkit-scrollbar{
  display: none;
}
</style>
